import { Clock3, Wrench } from "lucide-react";

export default function MaintenancePage() {
  return (
    <main
      className="relative flex min-h-[100dvh] items-center justify-center overflow-hidden bg-[#faf9f6] px-6 py-16 text-[#192733]"
      data-testid="maintenance-page"
    >
      <div className="paper-texture absolute inset-0" aria-hidden="true" />

      <section className="relative w-full max-w-2xl text-center" aria-labelledby="maintenance-title">
        <img
          src="/icon-192.png"
          alt="Culture Ken"
          className="mx-auto mb-8 h-24 w-24 rounded-lg shadow-sm sm:h-28 sm:w-28"
        />

        <div className="mx-auto mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-[#f4e6dc] text-[#b9571f]">
          <Wrench className="h-6 w-6" aria-hidden="true" />
        </div>

        <p className="mb-3 text-sm font-bold uppercase text-[#b9571f]">
          Scheduled maintenance
        </p>
        <h1 id="maintenance-title" className="text-4xl font-bold sm:text-5xl">
          We will be back shortly
        </h1>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-8 text-[#5c6872] sm:text-xl">
          Culture Ken is temporarily unavailable while we make improvements. Please check back
          soon.
        </p>

        <div className="mt-8 flex items-center justify-center gap-2 text-sm font-medium text-[#5c6872]">
          <Clock3 className="h-5 w-5 text-[#b9571f]" aria-hidden="true" />
          <span>Thank you for your patience.</span>
        </div>
      </section>
    </main>
  );
}
